<template>
  <section class="obra-stats-panel" aria-labelledby="obra-stats-title">
    <div class="obra-section-heading">
      <span id="obra-stats-title" class="obra-section-heading__eyebrow">Estatísticas</span>
    </div>
    <div class="obra-stats-panel__grid">
      <div v-for="stat in stats" :key="stat.label" class="obra-stats-panel__item">
        <span class="obra-stats-panel__metric">
          <v-icon size="28" color="var(--zinnes-primary)">{{ stat.icon }}</v-icon>
          <span class="obra-stats-panel__value">{{ formatNumber(stat.value) }}</span>
        </span>
        <span class="obra-stats-panel__label">{{ stat.label }}</span>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ObraStatsPanel',
  props: {
    project: { type: Object, default: () => ({}) },
    chapters: { type: Array, default: () => [] },
  },
  computed: {
    stats() {
      const project = this.project || {};
      const values = [{ label: 'Capítulos', value: this.chapters.length, icon: 'mdi-book-open-page-variant' }];
      if (project.likes_count !== undefined || project.likes !== undefined) values.push({ label: 'Curtidas', value: project.likes_count ?? project.likes ?? 0, icon: 'mdi-heart' });
      if (project.views !== undefined || project.views_count !== undefined) values.push({ label: 'Visualizações', value: project.views ?? project.views_count ?? 0, icon: 'mdi-eye' });
      if (project.comments !== undefined || project.comments_count !== undefined) values.push({ label: 'Comentários', value: project.comments ?? project.comments_count ?? 0, icon: 'mdi-comment' });
      return values;
    },
  },
  methods: {
    formatNumber(value) {
      const number = Number(value || 0);
      if (number >= 1000000) return `${(number / 1000000).toFixed(number >= 10000000 ? 0 : 1)}M`;
      if (number >= 1000) return `${(number / 1000).toFixed(number >= 10000 ? 0 : 1)}k`;
      return String(number);
    },
  },
};
</script>
